module.exports = __webpack_public_path__ + "static/img/featrue4.43a4bcad.jpg";